import type { ServicePeriod, ServicePeriodHistory } from '../types/servicePeriod'

export function needsExpiredAnchorPeriod(service?: userServicesAttributes | null): boolean {
  return Boolean(service?.id && service.status === 'off'
    && service.plan_id !== 1 && service.plan_id !== -1
    && service.billing_mode == null && service.period_start == null && service.period_end == null
    && Number(service.extra?.buy_length) <= 1)
}

// History describes the ended subscription only; never restore these fields onto
// the live service, where they also control pricing and renewal actions.
export function expiredAnchorPeriod(
  service: userServicesAttributes,
  history: ServicePeriodHistory,
): ServicePeriod | null {
  if (!needsExpiredAnchorPeriod(service) || history.service_id !== service.id) return null
  const period = history.periods[0]
  if (!period || period.service_id !== service.id || period.user_id !== service.user_id
    || period.plan_id !== service.plan_id || period.billing_mode !== 'anchor') return null
  if (!['expire:auto_rebuy_off', 'expire:money_not_enough', 'expire:user_missing',
    'clear_anchor:off_last_period', 'clear_anchor:stopped_without_prepaid'].includes(period.end_reason)) return null

  const dates = [period.period_start, period.period_end, period.ended_at]
  if (dates.some(value => typeof value !== 'string' || !value.trim())) {
    throw new Error('Invalid expired anchor period')
  }
  const [start, end, endedAt] = dates.map(value => new Date(value).getTime())
  if (![start, end, endedAt].every(Number.isFinite) || end! <= start! || endedAt !== end) {
    throw new Error('Invalid expired anchor period')
  }
  const buyTime = service.extra?.buy_time
  if (!buyTime || !Number.isFinite(+new Date(buyTime))) return null
  // Repurchases update buy_time. A legacy-to-anchor bridge can retain an earlier
  // buy_time, so equality with period_start would reject a valid first period.
  if (+new Date(buyTime) >= end!) return null
  return period
}
